module.exports = __webpack_public_path__ + "img/fellowfinancebusiness@2x.9ac3d46.png";